const iframes = document.querySelectorAll('.iframe-component')

function updateIframeComponents() {
    iframes.forEach(iframeContainer => {
        var iframe = iframeContainer.querySelector('.iframe-component__iframe');
        var includesCookies = iframe.getAttribute('data-cookies') == "1";
        if ((includesCookies && allCookiesIsAccepted()) || !includesCookies) {
            var overlay = iframeContainer.querySelector('.iframe-component__overlay');
            if (overlay != null) {
                iframe.classList.remove('iframe-component__iframe--hidden');
                var url = iframe.getAttribute('data-src');
                iframe.setAttribute('src', url);
                overlay.remove();
            }
        }
    })
}

function allCookiesIsAccepted() {
    return (CookieConsent.consented == true && CookieConsent.consent.necessary == true && CookieConsent.consent.preferences == true && CookieConsent.consent.statistics == true && CookieConsent.consent.marketing == true);
}

window.addEventListener('CookiebotOnAccept', function (e) {
    updateIframeComponents();    
}, false);


updateIframeComponents();